import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { addAccount } from "@NA/Services/ADIGetStatesService";

interface CrateAccountParameter {
    Account: string,
    AccountSuffix: string,
    Email: string,
    FirstName: string,
    LastName: string,
    JobTitle: string,
    Role: string,
    CompanyName: string,
    Address: string,
    City: string,
    State: string,
    Country: string,
    Pincode: string,
    BusinessPhone: string,
    MobilePhone: string,
    NewsletterSubscription: string,
    Terms: string,
    emailSent: boolean,
    message: string;
    onSuccess?: (result: any) => void;
    onError?: (error: string) => void;
}

export interface CreateAccountApiParameter {
    Account: string,
    AccountSuffix: string,
    Email: string,
    FirstName: string,
    LastName: string,
    JobTitle: string,
    Role: string,
    // Below code commented in P21 Spire, but not in Spire Prod.
   // CompanyName: string ,
    //Address: string,
    //City: string,
    //State: string,
   // Country: string,
   // Pincode: string,
    BusinessPhone: string,
    MobilePhone: string,
    NewsletterSubscription: string,
    Terms: string
}

interface AddAccountResultCustom {
    toEmail: string;
    uri: string;
    properties: { [key: string]: string };
    emailSent: boolean;
}

type HandlerType = CustomApiHandler<CreateAccountApiParameter, CrateAccountParameter, AddAccountResultCustom>;

export const SubmitOnlineRegnForm: HandlerType = async props => {
    const { 
        Account, AccountSuffix, Email, FirstName, LastName,
        JobTitle, Role,  //CompanyName, Address, City, State, Country, Pincode: properties has been not used in P21 
        BusinessPhone, MobilePhone, NewsletterSubscription, Terms
    } = props.parameter;

    props.apiResult = await addAccount({ 
        Account, AccountSuffix, Email, FirstName, LastName,
        JobTitle, Role, //CompanyName, Address, City, State, Country, Pincode: properties has been not used in P21 
        BusinessPhone, MobilePhone, NewsletterSubscription, Terms
    });
};

export const chain = [SubmitOnlineRegnForm];

const submitOnlineRegnForm = createHandlerChainRunner(chain, "SubmitOnlineRegnForm");
export default submitOnlineRegnForm;
